import "./footer.scss";
const Footer = () => {
  return (
    <footer>
      <div>Movie App</div>
      <div>&copy;2023, Moie, Inc. or it's affiliates</div>
    </footer>
  );
};
export default Footer;
